import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { Actions, Getters, Mutations, CustomerState } from '@/interfaces/store/customer'
import { RootState } from '@/interfaces/store/root'
import CustomerInfo from '@/interfaces/customer-info'

export const state: CustomerState = {
  phoneNumber: undefined,
  points: undefined,
  customerType: undefined,
  clubcardNo: undefined,
  tieredPoints: undefined
}

export const getters: GetterTree<CustomerState, RootState> & Getters = {}

export const actions: ActionTree<CustomerState, RootState> & Actions = {
  async fetchCustomer({ commit }, customerInfo: CustomerInfo) {
    commit('updateCustomer', customerInfo)

    return customerInfo
  },
}

export const mutations: MutationTree<CustomerState> & Mutations = {
  updateCustomer(state: CustomerState, customerInfo: CustomerInfo) {
    state.clubcardNo = customerInfo.clubcardNo
    state.phoneNumber = customerInfo.phoneNumber
    state.points = customerInfo.points
    state.customerType = customerInfo.customerType
    state.expiryDateOfCoin = customerInfo.expiryDateOfCoin
    state.tieredPoints = customerInfo.tieredPoints
  }
}

export const store: Module<CustomerState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
